import type { MembershipViewModel } from "../memberships/api/membership"
import type { AppSubContextType } from "../types/app-context"
import type { HourReportFormMembershipOption } from "./api/schemas"

export type ResolvedMembership = {
  id: string
  name: string
}

type ResolveDefaultMembershipArgs = {
  subContext: AppSubContextType | null
  authUserMembership: Pick<MembershipViewModel, "id" | "fullname"> | undefined
  canReportOthersHours: boolean
}

export const resolveDefaultMembership = ({
  subContext,
  authUserMembership,
  canReportOthersHours,
}: ResolveDefaultMembershipArgs): ResolvedMembership | null => {
  const isMemberSubContext = subContext?.type === "member"

  if (subContext && isMemberSubContext && canReportOthersHours) {
    return {
      id: subContext.id,
      name: subContext.name,
    }
  }

  if (authUserMembership) {
    return {
      id: authUserMembership.id,
      name: authUserMembership.fullname,
    }
  }

  return null
}

type ResolveCurrentMembershipArgs = {
  membershipId: string | null
  membershipOptions: HourReportFormMembershipOption[]
  initialMembership: ResolvedMembership | null
}

export const resolveCurrentMembership = ({
  membershipId,
  membershipOptions,
  initialMembership,
}: ResolveCurrentMembershipArgs): ResolvedMembership | null => {
  if (!membershipId) return null
  if (membershipId === initialMembership?.id) return initialMembership

  const membershipOption = membershipOptions.find(({ id }) => id === membershipId)
  if (membershipOption) return { id: membershipOption.id, name: membershipOption.userFullname }

  return null
}
